import { makeStyles } from '@material-ui/core';
import { edekaColors } from '../../theme/edekaColors';

const useStyles = makeStyles({
  svg: {
    width: 32,
    height: 32,
    display: 'block',
  },
});

/** Sidebar logo (collapsed): yellow tile with blue E (EDEKA badge). */
export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect width="64" height="64" rx="8" fill={edekaColors.yellow} />
      <path
        fill={edekaColors.blueActive}
        d="M14 14h36v8H24v8h26v8H24v8h26v8H14V14z"
      />
    </svg>
  );
};
